<template>
  <v-row no-gutters>
    <v-col>
      <header-admiral v-if="template === 'admiral'" :instance="instance" :message="message" :status="status" :color-background="colorBackground" />
      <header-classic v-else-if="template === 'classic'" :instance="instance" :message="message" :status="status" :color-background="colorBackground" />
      <header-modern v-else-if="template === 'modern'" :instance="instance" :message="message" :status="status" :color-background="colorBackground" />
      <email-detail v-if="status === 'succeeded'" :instance="instance" />
      <email-footer />
    </v-col>
  </v-row>
</template>
<script>
import EmailDetail from '@/components/reminders/payments/EmailDetail'
import EmailFooter from '@/components/reminders/EmailFooter'
import HeaderAdmiral from '@/components/reminders/payments/headers/Admiral'
import HeaderClassic from '@/components/reminders/payments/headers/Classic'
import HeaderModern from '@/components/reminders/payments/headers/Modern'
import ReminderViewMixin from '@/mixins/ReminderViewMixin'
export default {
  props: {
    template: {
      type: String,
      required: false,
      default: () => ('modern')
    },
    status: {
      type: String,
      required: false,
      default: () => ('succeeded')
    },
    message: {
      type: String,
      required: false,
      default () {
        return 'Gracias, hemos recibido tu pago. Esperamos que estés disfrutando de nuestro servicio.'
      }
    }
  },
  components: {
    EmailDetail,
    EmailFooter,
    HeaderAdmiral,
    HeaderClassic,
    HeaderModern
  },
  mixins: [
    ReminderViewMixin
  ]
}
</script>